import React, { useState } from "react";
import "./CitasPasadasTable.css";

export default function CitasPasadasTable({
  citas,
  dateFilter,
  setDateFilter,
  selectedSesion,
  toggleSesionDetalle,
  nuevoComentario,
  setNuevoComentario,
  handleAgregarComentario,
}) {
  const PAGE_SIZE = 5;
  const [page, setPage] = useState(1);

  const filtered = citas.filter((c) => {
    if (!dateFilter) return true;
    const fecha = new Date(c.start_datetime).toISOString().slice(0, 10);
    return fecha === dateFilter;
  });

  const totalPages = Math.ceil(filtered.length / PAGE_SIZE);
  const start = (page - 1) * PAGE_SIZE;
  const items = filtered.slice(start, start + PAGE_SIZE);

  return (
    <>
      <div className="pv-filter">
        <input
          type="date"
          value={dateFilter}
          onChange={(e) => setDateFilter(e.target.value)}
        />
        {dateFilter && (
          <button className="clear-btn" onClick={() => setDateFilter("")}>
            Limpiar
          </button>
        )}
      </div>

      {filtered.length === 0 ? (
        <p>No hay citas realizadas.</p>
      ) : (
        <>
          <div className="pv-table-wrapper">
            <table className="pv-table progreso">
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Inicio</th>
                  <th>Fin</th>
                  <th>Especialidad</th>
                  <th>Servicio</th>
                  <th>Tipo</th>
                  <th>Ver</th>
                </tr>
              </thead>
              <tbody>
                {items.map((c) => {
                  const start = new Date(c.start_datetime);
                  const end = new Date(c.end_datetime);
                  const isSelected = selectedSesion?.id === c.id;
                  return (
                    <React.Fragment key={c.id}>
                      <tr>
                        <td>{start.toLocaleDateString("es-ES")}</td>
                        <td>
                          {start.toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                        </td>
                        <td>
                          {end.toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                        </td>
                        <td>{c.specialty || "-"}</td>
                        <td>{c.service_code || "-"}</td>
                        <td>
                          {c.is_group
                            ? `Grupo (${c.group_size || "-"})`
                            : "Individual"}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          <button
                            className="icon-btn eye-btn"
                            onClick={() =>
                              toggleSesionDetalle(isSelected ? null : c)
                            }
                          >
                            <i className="fa fa-eye" />
                          </button>
                        </td>
                      </tr>

                      {isSelected && (
                        <tr className="sesion-detalle-row">
                          <td colSpan="7" style={{ padding: 0 }}>
                            <div className="sesion-detalle-wrapper">
                              <div className="sesion-detalle">
                                <h4>📝 Detalle de la sesión</h4>
                                <p>
                                  <strong>Especialidad:</strong> {c.specialty}
                                </p>
                                <p>
                                  <strong>Servicio:</strong> {c.service_code}
                                </p>
                                <p>
                                  <strong>Tipo:</strong>{" "}
                                  {c.is_group
                                    ? `Grupo (${c.group_size})`
                                    : "Individual"}
                                </p>

                                <div className="comentario-box">
                                  <h5>💬 Comentario profesional</h5>
                                  {c.comentario_profesional ? (
                                    <>
                                      <p>{c.comentario_profesional}</p>
                                      <p className="meta">
                                        👤{" "}
                                        {c.comentario_profesional_autor || "—"} · 🕓{" "}
                                        {c.comentario_profesional_fecha
                                          ? new Date(
                                              c.comentario_profesional_fecha
                                            ).toLocaleString("es-ES")
                                          : "—"}
                                      </p>
                                    </>
                                  ) : (
                                    <p className="empty">
                                      No hay comentarios aún.
                                    </p>
                                  )}
                                </div>

                                <div className="comentario-form">
                                  <h5>✍️ Añadir comentario</h5>
                                  <textarea
                                    rows="3"
                                    value={nuevoComentario}
                                    onChange={(e) =>
                                      setNuevoComentario(e.target.value)
                                    }
                                    placeholder="Escribe un comentario..."
                                  ></textarea>
                                  <button
                                    className="primary-btn"
                                    onClick={() =>
                                      handleAgregarComentario(c.id)
                                    }
                                    disabled={!nuevoComentario.trim()}
                                  >
                                    Guardar comentario
                                  </button>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>

          {totalPages > 1 && (
            <div className="pagination">
              <button onClick={() => setPage(page - 1)} disabled={page === 1}>
                ← Anterior
              </button>
              <span>
                Página {page} de {totalPages}
              </span>
              <button
                onClick={() => setPage(page + 1)}
                disabled={page === totalPages}
              >
                Siguiente →
              </button>
            </div>
          )}
        </>
      )}
    </>
  );
}
